import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Slider from 'react-slick'
import {bindActionCreators} from 'redux'
import {Link} from 'react-router-dom'
import classNames from 'classnames'
import {connect} from 'react-redux'
import ReactMarkdown from 'react-markdown/with-html'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import CodeBlock from './Codeblock'
import './slick/slick.css'
import './slick/slick-theme.css'

import {colors, Typography, withStyles, List, ListItem, ListItemText, Avatar, Button, IconButton} from '@material-ui/core'

import DownloadReleaseIcon from '@material-ui/icons/CloudDownload'
import DownloadSourceIcon from '@material-ui/icons/Code'
import VersionIcon from '@material-ui/icons/Whatshot'
import ArrowRight from '@material-ui/icons/ArrowRight'
import ArrowLeft from '@material-ui/icons/ArrowLeft'

import {ArrowToolTip, Expandable, PageContainer, MaterialIcon} from '../../components/components'
import {projectActions, metaActions} from '../../core/actions'
import {apiResourcesUrl} from '../../core/request'
import {titlePrefix} from '../../index'

const styles = theme => ({
    container: {
        flexDirection: 'column'
    },

    section: {
        '&:nth-child(n+3)': {
            paddingTop: '5em',
            paddingBottom: '5em'
        }
    },

    title: {
        textAlign: 'center',
        fontSize: '1.5em',
        paddingTop: '2em',
        paddingBottom: '1em',
        fontWeight: 300
    },

    infoTextContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
        paddingBottom: '0.4em'
    },

    infoText: {
        fontWeight: 300,
        paddingRight: '0.1em'
    },

    expandableContentContainer: {
        flexDirection: 'column',
        justifyContent: 'center'
    },

    expandableHeaderIcon: {
        marginRight: '1em'
    },

    updatedBadge: {
        backgroundColor: colors.orange[600]
    },

    metaRowContainer: {
        display: 'flex',
        justifyContent: 'center'
    },

    metaIcon: {
        height: '3.5em',
        width: 'auto',
        marginLeft: '1em',
        marginRight: '1em'
    },

    slider: {
        width: '1px',
        flex: 1
    },

    renderScreenshotsContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },

    screenShotContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '&:focus': {
            outline: 'none'
        }
    },

    screenShotCaption: {
    },

    screenShotImg: {
        border: '1px solid rgba(0, 0, 0, 0.2)',
        maxWidth: '99%',
        height: 'auto',
        cursor: 'zoom-in'
    },

    caption1: {
        textAlign: 'center'
    },

    caption2: {
        textAlign: 'center',
        paddingBottom: '1em'
    },

    arrow: {
        fontSize: '3em',
        '&:hover': {
            color: '#888888'
        }
    },

    readmeTextStyle: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif']
    },

    downloadButton: {
        backgroundColor: colors.grey[600],
        color: '#fff',
        '&:hover': {
            backgroundColor: colors.grey[700]
        },
        [theme.breakpoints.down('sm')]: {
            flex: 1
        }
    },

    downloadButtonText: {
        display: 'flex',
        flex: 1,
        color: '#000',
        textDecoration: 'none'
    },

    leftArrowIcon: {
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        }
    },

    rightArrowIcon: {
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        }
    },

    link: {
        color: 'inherit',
        textDecoration: 'underline'
    },

    noUnderLine: {
        textDecoration: 'none'
    },

    featuresList: {
        border: '1px solid rgba(0, 0, 0, 0.12)',
        boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)',
        padding: 0
    },

    lightBoxTitle: {
        position: 'absolute'
    }
})

const mapStateToProps = state => ({
    isLoadingDetails: state.project.isLoadingDetails,
    projectDetails: state.project.projectDetails,
    user: state.auth.user,
    error: state.project.error
})

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({...projectActions, ...metaActions}, dispatch)
})

const HotLink = {
    BasicEdit: '#basic',
    MediaEdit: '#media',
    DownloadsEdit: '#downloads',
    NotesEdit: '#features',
    ReadmeEdit: '#help'
}


const customStyles = {
    content: {
        top: '4em'
    }
};


class Details extends Component {
    state = {
        isLightBoxOpen: false,
        lightBoxCurrentIndex: 0
    }
    componentDidMount () {
        document.title = `${titlePrefix}Getting Info..`

        this.id = this.props.match.params.id
        this.props.getProjectDetails(this.props.match.params.id)
    }

    sectionTitle = (title, hotEditLink, underline = true) => {
        const {classes: styles, user, projectDetails} = this.props
        const projectId = projectDetails ? projectDetails.id : ''
        return (
            <Typography variant="h6" color="inherit" className={styles.title}>
                { user ? (
                    <ArrowToolTip title="Edit">
                        <Link to={`${projectId}/edit${hotEditLink}`} className={classNames(styles.link, !underline && styles.noUnderLine)}>
                            {title}
                        </Link>
                    </ArrowToolTip>
                ) : title}
            </Typography>
        )
    }

    infoField = (label, value) => {
        const {classes: styles} = this.props
        return (
            <div className={styles.infoTextContainer}>
                <Typography variant="h6" color="inherit" className={styles.infoText}>
                    {label}:
                </Typography>
                <Typography variant="body1" color="inherit" className={styles.infoText}>
                    {value}
                </Typography>
            </div>
        )
    }

    renderDownloadableData = () => {
        const {classes: styles, projectDetails} = this.props
        const { releases, sources } = projectDetails
        const hasRelease = releases.length > 0
        const hasSource = sources.length > 0
        return (
            <div>
                <Expandable className={styles.expandableContentContainer} title={'Releases'} disabled={!hasRelease} badgeText={hasRelease ? 'Public' : 'Private'}
                    icon={<DownloadReleaseIcon className={styles.expandableHeaderIcon} />}
                >
                    {releases.map((release, index) => (
                        <Expandable key={index} title={release.version} badgeText={moment(release.updated_at).fromNow()}
                            badgeClassName={styles.updatedBadge}
                            icon={<VersionIcon className={styles.expandableHeaderIcon} />}
                        >
                            <a className={styles.downloadButtonText} href={`${apiResourcesUrl}/${this.id}/release-files/${release.version}/${release.fileUrl}`}>
                                <Button variant="outlined" color="primary" className={styles.downloadButton}>
                                    Download
                                </Button>
                            </a>
                        </Expandable>
                    ))}
                </Expandable>

                <Expandable className={styles.expandableContentContainer} title={'Sources'} disabled={!hasSource} badgeText={hasSource ? 'Public' : 'Private'}
                    icon={<DownloadSourceIcon className={styles.expandableHeaderIcon} />}
                >
                    {sources.map((source, index) => (
                        <Expandable key={index} title={source.version} badgeText={moment(source.updated_at).fromNow()}
                            badgeClassName={styles.updatedBadge}
                            icon={<VersionIcon className={styles.expandableHeaderIcon} />}
                        >
                            <a className={styles.downloadButtonText} href={`${apiResourcesUrl}/${this.id}/source-files/${source.version}/${source.fileUrl}`}>
                                <Button variant="outlined" color="primary" className={styles.downloadButton}>
                                    Download
                                </Button>
                            </a>
                        </Expandable>
                    ))}
                </Expandable>
            </div>
        )
    }

    renderMetaIcons = metaData => {
        const {classes: styles} = this.props
        return (
            <div className={styles.metaRowContainer}>
                {metaData.map((meta, index) => (
                    <ArrowToolTip key={index} title={meta.name}>
                        <a target="_blank" rel="noopener noreferrer" href={`https://www.google.com/search?q=${meta.name}`}>
                            <img alt={meta.name} src={`${apiResourcesUrl}/meta/${meta.iconUrl}`} className={styles.metaIcon} />
                        </a>
                    </ArrowToolTip>
                ))}
            </div>
        )
    }

    onSliderArrowClicked = isNext => () => {
        if (isNext) this.slider.slickNext()
        else this.slider.slickPrev()
    }

    renderScreenShots = () => {
        const {classes: styles, projectDetails} = this.props
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            className: styles.slider
        }
        return (
            <div className={styles.renderScreenshotsContainer}>
                {projectDetails.screenshots.length > 1 &&
                <IconButton onClick={this.onSliderArrowClicked(false)} className={styles.leftArrowIcon}>
                    <ArrowLeft
                        color={'action'}
                        fontSize={'large'}
                        classes={{root: styles.arrow}}
                    />
                </IconButton>}
                <Slider ref={ref => (this.slider = ref)} {...settings}>
                    {projectDetails.screenshots.map((screenshot, index) => (
                        <div key={index}>
                            <div className={styles.screenShotContainer}>
                                <Typography variant="h6" color="inherit" className={styles.caption1}>
                                    {screenshot.caption1}
                                </Typography>
                                <Typography variant="body1" color="inherit" className={styles.caption2}>
                                    {screenshot.caption2}
                                </Typography>
                                <img onClick={this.onShowFullscreen(index)} alt={screenshot.caption1} className={styles.screenShotImg} src={`${apiResourcesUrl}/${projectDetails.id}/screenshots/${screenshot.imgUrl}`} />
                            </div>
                        </div>
                    ))}
                </Slider>
                {projectDetails.screenshots.length > 1 &&
                <IconButton onClick={this.onSliderArrowClicked(true)} className={styles.rightArrowIcon}>
                    <ArrowRight
                        color={'action'}
                        fontSize={'large'}
                        classes={{root: styles.arrow}}
                    />
                </IconButton>}
            </div>
        );
    }

    renderAdditionalInfo = () => {
        const {classes: styles, projectDetails: {features}} = this.props
        return (
            <List component="ul" className={styles.featuresList}>
                {features.map((info, index) => (
                    <ListItem key={index} divider={index < features.length - 1}>
                        <Avatar>
                            <MaterialIcon icon={info.icon} />
                        </Avatar>
                        <ListItemText primary={info.description} />
                    </ListItem>
                ))}
            </List>
        )
    }

    onShowFullscreen = lightBoxCurrentIndex => () => {
        this.setState({lightBoxCurrentIndex, isLightBoxOpen: true})
    }

    render() {
        const {classes: styles, projectDetails, isLoadingDetails} = this.props
        let screenshots = []
        const {isLightBoxOpen, lightBoxCurrentIndex} = this.state

        if (projectDetails) {
            document.title = `${titlePrefix}${projectDetails.name}`
            screenshots = projectDetails.screenshots.map(screenshot => `${apiResourcesUrl}/${projectDetails.id}/screenshots/${screenshot.imgUrl}`)
        }
        return (
            <PageContainer className={styles.container} isLoadingContent={isLoadingDetails} loaderText={'Getting Info'}>
                { projectDetails &&
                <div>
                    <div className={styles.section}>
                        {this.sectionTitle('Info', HotLink.BasicEdit)}
                        {this.infoField('Name', projectDetails.name)}
                        {this.infoField('Authors', projectDetails.authors)}
                        {this.infoField('Description', projectDetails.description)}
                    </div>
                    <div className={styles.section}>
                        {this.sectionTitle('Downloads', HotLink.DownloadsEdit)}
                        {this.renderDownloadableData()}
                    </div>
                    <div className={styles.section}>
                        {this.sectionTitle('Categories | Interfaces | Platforms', HotLink.BasicEdit, false)}
                        {this.renderMetaIcons([...projectDetails.categories, ...projectDetails.interfaces, ...projectDetails.platforms])}
                        {this.sectionTitle('Languages | Frameworks', HotLink.BasicEdit, false)}
                        {this.renderMetaIcons([...projectDetails.languages, ...projectDetails.frameworks])}
                    </div>
                    <div className={styles.section}>
                        {this.sectionTitle('Previews', HotLink.MediaEdit)}
                        {this.renderScreenShots()}
                    </div>
                    { projectDetails.features.length > 0 &&
                    <div className={styles.section}>
                        {this.sectionTitle('Additional Info', HotLink.NotesEdit)}
                        {this.renderAdditionalInfo()}
                    </div>
                    }
                    { projectDetails.readme &&
                    <div className={styles.section}>
                        {this.sectionTitle('Help Setup/Guide', HotLink.ReadmeEdit)}
                        <ReactMarkdown skipHtml={false} escapeHtml={false} renderers={{code: CodeBlock}} source={projectDetails.readme} className={styles.readmeTextStyle} />
                    </div>
                    }
                </div>
                }
                {isLightBoxOpen && (
                    <Lightbox
                        imagePadding={120}
                        imageTitle={<Typography variant="body1" color="inherit" className={styles.lightBoxTitle}>{projectDetails.screenshots[lightBoxCurrentIndex].caption2 || projectDetails.screenshots[lightBoxCurrentIndex].caption1}</Typography>}
                        reactModalStyle={customStyles}
                        mainSrc={screenshots[lightBoxCurrentIndex]}
                        nextSrc={screenshots[(lightBoxCurrentIndex + 1) % screenshots.length]}
                        prevSrc={screenshots[(lightBoxCurrentIndex + screenshots.length - 1) % screenshots.length]}
                        onCloseRequest={() => this.setState({ isLightBoxOpen: false })}
                        onMovePrevRequest={() =>
                            this.setState({
                                lightBoxCurrentIndex: (lightBoxCurrentIndex + screenshots.length - 1) % screenshots.length
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                lightBoxCurrentIndex: (lightBoxCurrentIndex + 1) % screenshots.length
                            })
                        }
                    />
                )}
            </PageContainer>
        );
    }

}

Details.propTypes = {
    classes: PropTypes.object,
    getProjectDetails: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Details))
